import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import VehicleServics from "../../../services/VehicleServics";
import Swal from "sweetalert2";
import Select from 'react-select';
import VehicleEdit from "./VehicleEdit";
import AssignDriver from "./AssignDriver";

const StoreVehicle = () => {
  const [open, setOpen] = useState(true);
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [open2, setOpen2] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [sort, setsort] = useState(50); // Number of items per page
  const activePag = useRef(0);
  const [test, setTest] = useState(0);
  const [run, setRun] = useState(0);
  const [selectedItem, setSelectedItem] = useState();
  const [searchQuery, setSearchQuery] = useState(""); // Search state

  const user = JSON.parse(localStorage.getItem('userDetails'));
  const availableStores = user?.data?.user?.store || [];
  const defaultStore = availableStores[0]?._id || '';

  const [stores, setStores] = useState(availableStores);
  const [selectedStore, setSelectedStore] = useState(defaultStore);

  // Function to change the displayed data based on pagination
  const changeData = (first, second) => {
    const domData = Array.from(
      document.querySelectorAll("#transactions-data tbody tr")
    );
    domData.forEach((row, index) => {
      if (index >= first && index < second) {
        row.classList.remove("d-none");
      } else {
        row.classList.add("d-none");
      }
    });
  };

  // Fetch data from API
  useEffect(() => {
    if (selectedStore) {
      setLoading(true);
      try {
        VehicleServics.getStoreVehicle(selectedStore).then((res) => {
          const filteredData = res.data.filter(item => {
            return (
              item?.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
              item?.assignedStore?.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
              item?.category?.name.toLowerCase().includes(searchQuery.toLowerCase())
            );
          });
          setData(filteredData);
        }).catch((error) => {
          console.log(error.response.data.message);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'Something went wrong!',
          });
        });
      } catch (error) {
        setError(error.message);
      }
    }
  }, [run, selectedStore, searchQuery]); // Re-fetch when searchQuery changes

  const handleStoreChange = (e) => {
    setSelectedStore(e.target.value);
    activePag.current = 0; // Reset pagination when store changes
  };

  // Pagination setup
  useEffect(() => {
    if (data.length > 0) {
      changeData(activePag.current * sort, (activePag.current + 1) * sort);
    }
  }, [data]);

  const pagination = Math.ceil(data.length / sort); // Calculate number of pages

  const onClick = (i) => {
    activePag.current = i;
    changeData(activePag.current * sort, (activePag.current + 1) * sort);
    setTest(i);
  };

  // Modal value
  const handleEditClick = (item) => {
    setSelectedItem(item); // Set the item to be edited
    setGridInsideModal(true); // Show modal
  };

  // Handle status toggle for Active users
  const handleStatusToggle = async (item) => {
    const newStatus = item.status === "inactive" ? "active" : "inactive";
    const updatedUser = { ...item, status: newStatus }; // Create updated user object

    try {
      await VehicleServics.updateVehicle(item._id, updatedUser); // Use the updateUser service
      setRun(prev => prev + 1); // Trigger re-fetch or re-render
      Swal.fire('Success!', `User status updated to ${newStatus}.`, 'success');
    } catch (error) {
      console.error(error);
      Swal.fire('Error!', 'There was a problem updating the user status.', 'error');
    }
  };

  return (
    <>
      <AssignDriver
        item={selectedItem}
        store={selectedStore}
        show={gridInsideModal}
        test={setTest}
        handleClose={() => setGridInsideModal(false)}
      />

      <div className="row">
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fas fa-filter me-2"></i>Filter
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open ? 'collapse' : 'expand'}`}
                  onClick={() => setOpen(!open)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-3 col-xxl-6">
                      <label className="ms-2">Search</label>
                      <input
                        type="text"
                        className="form-control mb-xl-0 mb-3"
                        placeholder="Search by Name, Store, Category"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </div>
                    <div className="col-xl-3 col-xxl-6">
                      <label className="form-label ms-2">Select Store</label>
                      <select
                        className="form-select mb-xl-0 mb-3 pt-3 pb-3"
                        value={selectedStore}
                        onChange={handleStoreChange}
                      >
                        {stores.map((store) => (
                          <option key={store._id} value={store._id}>
                            {`${store.name}, ${store.location}`}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>

          <div className="filter cm-content-box box-primary">
            <div className={`content-title`}>
              <div className="cpa">
                <i className="fa fa-list me-2" aria-hidden="true"></i> Owen Vehicle <span className="badge bg-orange ms-2">{data.length}</span>
              </div>
              <div className="tools">
                <Link
                  to={"#"}
                  className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                  onClick={() => setOpen2(!open2)}
                >
                  <i className="fas fa-angle-up"></i>
                </Link>
              </div>
            </div>
            <Collapse in={open2}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <div className="table-responsive">
                    <div
                      id="content_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        className="table table-bordered table-responsive-lg table-striped table-condensed flip-content"
                        id="transactions-data"
                      >
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Vehicle Name</th>
                            <th>Assigned Driver</th>
                            <th>Category</th>
                            <th>Store</th>
                            <th>Capacity</th>
                            <th>Owen Status</th>
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(data) && data.length > 0 ? (
                            data.map((item, index) => (
                              <tr key={index}>
                                <td>{activePag.current * sort + index + 1}</td>
                                <td>{item?.name || 'No Name'}</td>
                                <td>
                                  {item?.assignedDrivers && item.assignedDrivers.length > 0
                                    ? item.assignedDrivers.map(driver => driver.name).join(", ")
                                    : "No Driver Assigned"}
                                </td>
                                <td>{item?.category?.name || 'No Category'}</td>
                                <td>{item?.assignedStore?.name || 'No Store'}</td>
                                <td>{item?.capacity || 'N/A'}</td>
                                <td>{item?.rentalStatus || 'N/A'}</td>
                                <td className="text-center">
                                  <button
                                    className="btn btn-primary btn-xs sharp"
                                    onClick={() => handleEditClick(item)}
                                  >
                                    <i className="fa fa-pencil"></i>
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7">No data available</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                        <div className="dataTables_info">
                          Showing {activePag.current * sort + 1} to{" "}
                          {Math.min(data.length, (activePag.current + 1) * sort)} of {data.length} entries
                        </div>
                        <div className="dataTables_paginate paging_simple_numbers">
                          <Link
                            className="paginate_button previous"
                            to="/location"
                            onClick={() =>
                              activePag.current > 0 &&
                              onClick(activePag.current - 1)
                            }
                          >
                            <i className="fa fa-angle-double-left" aria-hidden="true"></i>
                          </Link>
                          <span>
                            {Array.from({ length: pagination }, (_, i) => (
                              <Link
                                key={i}
                                to="/location"
                                className={`paginate_button ${activePag.current === i ? "current" : ""}`}
                                onClick={() => onClick(i)}
                              >
                                {i + 1}
                              </Link>
                            ))}
                          </span>
                          <Link
                            className="paginate_button next"
                            to="/location"
                            onClick={() =>
                              activePag.current + 1 < pagination &&
                              onClick(activePag.current + 1)
                            }
                          >
                            <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
};

export default StoreVehicle;
